/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import GroupIcon from "@material-ui/icons/Group";
import { IconChecboxGroup, IconCheckboxGroupData } from "./IconChecboxGroup";

const labelStyle = {
  enable: {
    color: "rgba(0,0,0,0.87)",
    fontSize: "0.8rem",
    marginLeft: "0.25rem",
  },
  disable: {
    color: "rgba(0,0,0,0.38)",
    fontSize: "0.8rem",
    marginLeft: "0.25rem",
  },
};

const iconStyle = {
  enable: {
    color: "rgba(0,0,0,0.87)",
    width: "0.8rem",
    height: "0.8rem",
  },
  disable: {
    color: "rgba(0,0,0,0.22)",
    width: "0.8rem",
    height: "0.8rem",
  },
};

export interface UserGroupIconCheckboxDef {
  name: string;
  label: string;
}

interface Props {
  defs: UserGroupIconCheckboxDef[];
  data: IconCheckboxGroupData;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/** ユーザーグループアイコンチェックボックスグループ */
export function UserGroupIconChecboxGroup(props: Props) {
  const { defs, data, handleChange } = props;

  const mergedDefs = defs.map((def: UserGroupIconCheckboxDef) => {
    return {
      name: def.name,
      label: {
        text: def.label,
        style: labelStyle,
      },
      icon: {
        node: <GroupIcon />,
        style: iconStyle,
      },
    };
  });

  //--------------------
  // コンポーネント
  return (
    <IconChecboxGroup
      defs={mergedDefs}
      data={data}
      handleChange={handleChange}
    />
  );
}
